const initialLabellingState = {
  chats: undefined,
  totalCount: undefined,
};

export default initialLabellingState;
